<template>
  <div>
    <div class="room-list-main">
      <el-form :inline="true" :model="d_room_list_from_line" class="demo-form-inline">
				
        <el-form-item label="店铺名称" class="from-label">
          <el-input size="small" v-model="d_room_list_from_line.s_shop_name" placeholder="请输入店铺名称" clearable></el-input>
        </el-form-item>

        <el-form-item label="包间名称" class="from-label">
          <el-input size="small" v-model="d_room_list_from_line.s_room_name" placeholder="请输入包间名称" clearable></el-input>
        </el-form-item>

        <el-form-item label="包间状态" class="from-label">
          <el-select
            v-model="queryRoomStatus"
            size="small"
            clearable
            placeholder="请选择文章标签"
            >
              
            <el-option
              v-for="item in d_room_list_from_line.l_room_status"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
            <el-button type="primary" @click="onSubmit" size="small" icon="el-icon-search">查询</el-button>
            <el-button type="primary" @click="on_reset" size="small" icon="el-icon-refresh">重置</el-button>
        </el-form-item>
				
			</el-form>


    <div style="margin-bottom: 20px;">
      <el-button type="primary" icon="el-icon-plus"
        size="mini" plain
        @click="add_room"
        >新增</el-button>
      
      <el-button type="success" icon="el-icon-edit"
        size="mini" plain :disabled="b_top_change_btn"
        @click="change_room(multipleSelection[0])"
        >修改</el-button>
      
      <el-button type="warning" icon="el-icon-search"
        size="mini" plain :disabled="b_top_find_btn"
        @click="show_room(multipleSelection[0])"
        >查询</el-button>
      
      <el-button type="danger" icon="el-icon-delete"
        size="mini" plain :disabled="b_top_remove_btn"
        @click="top_remove_btn_func"
        >删除</el-button>
    </div>
            
    <div>
      <template>
        <el-table
          :data="l_table_data"
          style="width: 100%;border-color:'#606266'"
          :default-sort = "{prop: 'date', order: 'descending'}"
          :header-cell-style="{background:'#f8f8f8', fontFamily:'Helvetica',fontSize:'14px'}"
          :cell-style="{color: '#666',fontSize:'14px'}"
          border
          @selection-change="handleSelectionChange">
                
          <el-table-column fixed type="selection" width="55"> </el-table-column>

          <el-table-column
            fixed
            align="center"
            prop="shop_name"
            label="店铺名称"
            sortable
            width="260">
          </el-table-column>

          <el-table-column
              align="center"
              prop="room_name"
              label="包间名称"
              sortable
              width="260">
          </el-table-column>

          <el-table-column
            align="center"
            label="包间主图"
            sortable
            width="120"
            >
            <template slot-scope="scope"> 
              <!-- 显示图片, 限制大小 -->
              <el-popover placement="top-start" title="包间主图(小程序订购列表展示)" trigger="hover">
                  <img  alt="" :src="scope.row.room_main_img" style="width:300px;height:300px;">
                  <img  slot="reference" :src="scope.row.room_main_img" style="width:25px;height:25px;">
              </el-popover>
              
            </template>
          </el-table-column>

          <el-table-column
            align="center"
            label="包间状态"
            sortable
            >
            <template slot-scope="scope"> 
              <el-tag type="info" v-if="scope.row.room_status == 0">
                <span> 空闲中 </span>
              </el-tag>
              <el-tag type="success" v-if="scope.row.room_status == 1">
                <span> 使用中 </span>
              </el-tag>
               <el-tag type="warning" v-if="scope.row.room_status == 2">
                <span> 锁定中 </span>
              </el-tag>
               <el-tag type="danger" v-if="scope.row.room_status == 3">
                <span> 待打扫 </span>
              </el-tag>
               <el-tag type="danger" v-if="scope.row.room_status == 4">
                <span> 待维修 </span>
              </el-tag>
              <el-tag type="danger" v-if="scope.row.room_status == 5">
                <span> 更改玩法 </span>
              </el-tag>

            </template>
          </el-table-column>

          <el-table-column
              align="center"
              prop="s_room_order"
              label="订单详情"
              sortable
              width="260">
          </el-table-column>


          <el-table-column
              align="center"
              fixed="right"
              label="设备控制"
              width="180">
              <template slot-scope="scope">
                  <el-button type="text" @click="EquipmentControl(scope.row)" icon="el-icon-unlock" size="small">设备控制</el-button>
                  <el-button type="text" @click="input_device_func(scope.row)" icon="el-icon-cpu" size="small">设备录入</el-button>
              </template>
          </el-table-column>

          <!-- <el-table-column
            align="center"
            fixed="right"
            label="操作"
            width="300">
            <template slot-scope="scope">
              <el-button type="text" @click="show_room(scope.row)" icon="el-icon-search" size="small" style="margin-left: 5px">查看包间</el-button>
              <el-button type="text" @click="change_room(scope.row)" icon="el-icon-edit" size="small" style="margin-left: 5px">编辑包间</el-button>
              
              <el-popconfirm
                title="确定删除此包间吗?"
                confirm-button-text='确定'
                cancel-button-text='取消'
                icon="el-icon-info"
                icon-color="red"
                @confirm="removeRoomBtn(scope.$index, scope.row)"
                style="margin-left: 10px">
                  <el-button type="text" icon="el-icon-delete" size="small" slot="reference">删除包间</el-button>
              </el-popconfirm>
                          
            </template>
          </el-table-column> -->

           <el-table-column
            align="center"
            fixed="right"
            label="操作"
            width="180">
              
              <template slot-scope="scope">
                <el-dropdown >
                  <el-button type="primary" size="small">
                    更多操作<i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">

                    <el-dropdown-item @click.native="show_room(scope.row)" style="color: #409eff; font-size:12px">
                      <i class="el-icon-search el-icon--right"></i><span>查看包间</span>
                    </el-dropdown-item>

                    <el-dropdown-item @click.native="change_room(scope.row)" style="color: #409eff; font-size:12px">
                      <i class="el-icon-edit el-icon--right"></i><span>编辑包间</span>
                    </el-dropdown-item>

                    <el-dropdown-item @click.native="on_delete_room(scope.row)" style="color: #409eff; font-size:12px">
                      <i class="el-icon-delete el-icon--right"></i><span>删除包间</span>
                    </el-dropdown-item>
                    
                    <el-dropdown-item @click.native="dispatch_event(scope.row)" style="color: #409eff; font-size:12px">
                      <i class="el-icon-document-add el-icon--right"></i><span>派遣</span>
                    </el-dropdown-item>
                  
                  </el-dropdown-menu>
                </el-dropdown>
                
              </template>
              
            </el-table-column>

          </el-table>

          <el-pagination
              @current-change="change_current_func"
              :current-page="i_current_page"
              :page-size="10"
              layout="total, prev, pager, next, jumper"
              :total="i_max_total"
              style="text-align:right; margin-top:15px"
              >
          </el-pagination>

        </template>
      </div>
    </div>

    <!-- 包间增改查数据 -->
    <el-dialog :visible.sync="b_room_dialog" :fullscreen="b_room_fullscreen" :before-close="this.$dialog_close" :show-close="false" width="1300px">
      <div slot="title" class="dialog-title">
        <span style="font-size: 18px; line-height: 24px; color: #303133;">新增包间</span>

        <el-button icon="el-icon-close" class='dialog-title-button' @click="b_room_dialog = false"></el-button>
				<el-button icon="el-icon-full-screen" class='dialog-title-button' @click="b_room_fullscreen = !b_room_fullscreen"></el-button>
			</div>

      <div is="room_info" @RoomInfoCallback="room_info_callback" :key="ref_components"
      :DialogType="dialog_type" :dSelectRoomData="d_select_room_data"></div>

    </el-dialog>

 
    

    <!-- 设备录入 -->
    <el-dialog :visible.sync="b_input_device_dialog" :fullscreen="b_input_device_fullscreen" :before-close="this.$dialog_close" :show-close="false">
  
			<div slot="title" class="dialog-title">
				<span style="font-size: 18px; line-height: 24px; color: #303133;">设备录入</span>
				<el-button icon="el-icon-close" class='dialog-title-button' @click="b_input_device_dialog = false"></el-button>
				<el-button icon="el-icon-full-screen" class='dialog-title-button' @click="b_input_device_fullscreen = !b_input_device_fullscreen"></el-button>
			</div>

      <el-form :model="deviceData" ref="deviceData" label-width="100px" @class="demo-deviceData">
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="设备名称" prop="device_name">
              <el-input v-model="deviceData.device_name" placeholder="请输入设备名称"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="设备ID" prop="device_id">
              <el-input v-model="deviceData.device_id" placeholder="请输入设备ID"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="父级网关ID" prop="device_parent_gateway">
              <el-input v-model="deviceData.device_parent_gateway" placeholder="请输入父级网关ID(空调遥控必填)"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="设备类型" prop="device_type">
              <el-select v-model="deviceData.device_type" clearable  placeholder="请选设备类型">
                <el-option
                  v-for="item in deviceType"
                  :key="item.value"
                  :value="item.value"
                  :label="item.label"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>
		  <div slot="footer" class="dialog-footer">
		    
		    <el-button type="primary" @click="input_device_cancel_func">取 消</el-button>
		    <el-button type="primary" @click="input_device_define_func">确 定</el-button>
		  </div>
		
		</el-dialog>

    <!-- 设备控制弹窗 -->
    <el-dialog :visible.sync="bEquipmentControlDialog" :fullscreen="bEquipmentControlFullscreen" :before-close="this.$dialog_close" :show-close="false" width="500px">
  
			<div slot="title" class="dialog-title">
				<span style="font-size: 18px; line-height: 24px; color: #303133;">设备控制</span>
				<el-button icon="el-icon-close" class='dialog-title-button' @click="bEquipmentControlDialog = false"></el-button>
				<el-button icon="el-icon-full-screen" class='dialog-title-button' @click="bEquipmentControlFullscreen = !bEquipmentControlFullscreen"></el-button>
			</div>

      <el-row :gutter="24">
        <el-col :span="24">
          <el-divider><i class="el-icon-s-tools"></i>电路控制</el-divider>
          <el-button type="primary" @click="PowerOn">断路器通电</el-button>
          <el-button type="primary" @click="PowerLoss">断路器断电</el-button>
        </el-col>

        <el-col :span="24">
          <el-divider><i class="el-icon-s-tools"></i>空调控制</el-divider>
          <el-button type="primary" @click="OpenAirCondition">开启空调</el-button>
          <el-button type="primary" @click="CloseAirCondition">关闭空调</el-button>
        </el-col>

        <el-col :span="24">
          <el-divider><i class="el-icon-s-tools"></i>门锁控制</el-divider>
          <el-button type="primary" @click="OpenDoor">开门</el-button>
        </el-col>

      </el-row>

		  <div slot="footer" class="dialog-footer">
		    
		    <el-button type="primary" @click="bEquipmentControlDialog = false">关 闭</el-button>
		  </div>
		
		</el-dialog>

    <!-- 派遣弹窗 -->
    <el-drawer
      :title="dispatch_drawer_title"
      :visible.sync="is_show_dispatch"
      :direction="direction"
      :before-close="dispatch_close">
      
      <div style="padding: 10px 16px;">
        <el-tabs v-model="s_dispatch_tab_active_index" @tab-click="dispathc_rawer_tabs_click">
          <el-tab-pane label="打扫派遣" name="first">

            <div style="padding: 10px 16px;">
              <el-form :model="d_dispatch_form" ref="d_dispatch_form" label-width="120px" width="300px">
                <el-form-item label="请选择派遣人" prop="cleanId">
                  <el-select
                    v-model="d_dispatch_form.cleanId"
                    size="small"
                    clearable
                    placeholder="请选择派遣人"
                   >
                    <el-option
                      v-for="key, value in d_dispatch_shop_info.shop_clean_worker_user_list_info"
                      :key="value"
                      :label="key"
                      :value="value">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item prop="time">
                  <el-button type="primary" round size="small" @click="dispatch_event_func(1)">确认派遣并修改包间状态</el-button>
                </el-form-item>
              </el-form>

              <el-divider><i class="el-icon-s-order"></i> 派单状态</el-divider>

              <div v-if="bClean === false" style="text-align:center;">
                <el-tag type="warning"> 当前无工单 </el-tag>
              </div>
      
              <div v-else>
                <el-timeline :v-mode="d_room_work_order_data">
                    <el-timeline-item :timestamp="d_room_work_order_data.d_clean_info.web_status_timestamp_one" placement="top" :color="d_room_work_order_data.d_clean_info.web_status_color_one" >
                      <el-card>
                        <h4>打扫工单派遣时间</h4>
                        <p>{{ d_room_work_order_data.d_clean_info.work_order_dispatch_user }} 提交于 {{ d_room_work_order_data.d_clean_info.work_order_create_time }}</p>
                      </el-card>
                    </el-timeline-item>

                    <el-timeline-item :timestamp="d_room_work_order_data.d_clean_info.web_status_timestamp_two" placement="top" :color="d_room_work_order_data.d_clean_info.web_status_color_two" >
                      <el-card>
                        <h4>到店打卡</h4>
                        <p>{{ d_room_work_order_data.d_clean_info.work_order_deal_user }} 提交于 {{ d_room_work_order_data.d_clean_info.status_time_two }}</p>
                        <p>打卡经纬度: {{ d_room_work_order_data.d_clean_info.work_order_arrive_latitude }}</p>
                      </el-card>
                    </el-timeline-item>

                    <el-timeline-item :timestamp="d_room_work_order_data.d_clean_info.web_status_timestamp_three" placement="top" :color="d_room_work_order_data.d_clean_info.web_status_color_three" >
                      <el-card>
                        <h4>打扫前拍照</h4>
                        <p>{{ d_room_work_order_data.d_clean_info.work_order_deal_user }} 提交于 {{ d_room_work_order_data.d_clean_info.status_time_three }}</p>
                        <el-image 
                          v-for='url in d_room_work_order_data.d_clean_info.img_list_three' :key="url.key"
                          style="width: 100px; height: 100px"
                          :src="url" 
                          :preview-src-list="d_room_work_order_data.d_clean_info.img_list_three">
                        </el-image>
                      </el-card>
                    </el-timeline-item>

                    <el-timeline-item :timestamp="d_room_work_order_data.d_clean_info.web_status_timestamp_four" placement="top" :color="d_room_work_order_data.d_clean_info.web_status_color_four" >
                      <el-card>
                        <h4>打扫后拍照</h4>
                        <p>{{ d_room_work_order_data.d_clean_info.work_order_deal_user }} 提交于 {{ d_room_work_order_data.d_clean_info.status_time_four }}</p>
                        <el-image 
                          v-for='url in d_room_work_order_data.d_clean_info.img_list_four' :key="url.key"
                          style="width: 100px; height: 100px"
                          :src="url" 
                          :preview-src-list="d_room_work_order_data.d_clean_info.img_list_four">
                        </el-image>
                      </el-card>
                    </el-timeline-item>

                    <el-timeline-item :timestamp="d_room_work_order_data.d_clean_info.web_status_timestamp_five" placement="top" :color="d_room_work_order_data.d_clean_info.web_status_color_five" >
                      <el-card>
                        <h4>确认设备正常拍照</h4>
                        <p>{{ d_room_work_order_data.d_clean_info.work_order_deal_user }} 提交于 {{ d_room_work_order_data.d_clean_info.status_time_five }}</p>
                        <el-image 
                          v-for='url in d_room_work_order_data.d_clean_info.img_list_five' :key="url.key"
                          style="width: 100px; height: 100px"
                          :src="url" 
                          :preview-src-list="d_room_work_order_data.d_clean_info.img_list_five">
                        </el-image>
                      </el-card>
                    </el-timeline-item>

                    <el-timeline-item :timestamp="d_room_work_order_data.d_clean_info.web_status_timestamp_six" placement="top" :color="d_room_work_order_data.d_clean_info.web_status_color_six" >
                      <el-card>
                        <h4>离店打卡</h4>
                        <p>{{ d_room_work_order_data.d_clean_info.work_order_deal_user }} 提交于 {{ d_room_work_order_data.d_clean_info.status_time_six }}</p>
                        <p>打卡经纬度: {{ d_room_work_order_data.d_clean_info.work_order_leave_latitude }}</p>
                      </el-card>
                    </el-timeline-item>
                </el-timeline>
              </div>
            </div>
          </el-tab-pane>

          <el-tab-pane label="维修派遣" name="second">

            <div style="padding: 10px 16px;">
              <el-form :model="d_dispatch_form" ref="d_dispatch_form" label-width="120px" width="300px">
                <el-form-item label="请选择派遣人" prop="repairId">
                  <el-select
                    v-model="d_dispatch_form.repairId"
                    size="small"
                    clearable
                    placeholder="请选择派遣人"
                    :ref="d_dispatch_shop_info"
                   >
                    <el-option
                      v-for="key, value in d_dispatch_shop_info.shop_repair_worker_user_list_info"
                      :key="value"
                      :label="key"
                      :value="value">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="请输入派遣内容" prop="work_order_reason">
                  <el-input
                    v-model="d_dispatch_form.work_order_reason"
                    size="small"
                    placeholder="维修问题描述">
                  </el-input>
                </el-form-item>

                <el-form-item prop="time">
                  <el-button type="primary" round size="small" @click="dispatch_event_func(2)">确认派遣并修改包间状态</el-button>
                </el-form-item>
              </el-form>
            
              <el-divider><i class="el-icon-s-order"></i> 派单状态</el-divider>
              
              <div v-if="bRepair === false" style="text-align:center;">
                <el-tag type="warning"> 当前无工单 </el-tag>
              </div>
      
              <div v-else>
                <el-timeline :v-mode="d_room_work_order_data">
                    <el-timeline-item :timestamp="d_room_work_order_data.d_repair_info.web_status_timestamp_one" placement="top" :color="d_room_work_order_data.d_repair_info.web_status_color_one" >
                      <el-card>
                        <h4>维修工单派遣时间</h4>
                        <p>{{ d_room_work_order_data.d_repair_info.work_order_dispatch_user }} 提交于 {{ d_room_work_order_data.d_repair_info.work_order_create_time }}</p>
                      </el-card>
                    </el-timeline-item>

                    <el-timeline-item :timestamp="d_room_work_order_data.d_repair_info.web_status_timestamp_two" placement="top" :color="d_room_work_order_data.d_repair_info.web_status_color_two" >
                      <el-card>
                        <h4>到店打卡</h4>
                        <p>{{ d_room_work_order_data.d_repair_info.work_order_deal_user }} 提交于 {{ d_room_work_order_data.d_repair_info.status_time_two }}</p>
                        <p>打卡经纬度: {{ d_room_work_order_data.d_repair_info.work_order_arrive_latitude }}</p>
                      </el-card>
                    </el-timeline-item>

                    <el-timeline-item :timestamp="d_room_work_order_data.d_repair_info.web_status_timestamp_three" placement="top" :color="d_room_work_order_data.d_repair_info.web_status_color_three" >
                      <el-card>
                        <h4>问题确认</h4>
                        <p>{{ d_room_work_order_data.d_repair_info.work_order_deal_user }} 提交于 {{ d_room_work_order_data.d_repair_info.status_time_three }}</p>
                        <p>{{ d_room_work_order_data.d_repair_info.work_order_reason }}</p>
                      </el-card>
                    </el-timeline-item>

                    <el-timeline-item :timestamp="d_room_work_order_data.d_repair_info.web_status_timestamp_four" placement="top" :color="d_room_work_order_data.d_repair_info.web_status_color_four" >
                      <el-card>
                        <h4>维修前拍照</h4>
                        <p>{{ d_room_work_order_data.d_repair_info.work_order_deal_user }} 提交于 {{ d_room_work_order_data.d_repair_info.status_time_four }}</p>
                        <el-image 
                          v-for='url in d_room_work_order_data.d_repair_info.img_list_four' :key="url.key"
                          style="width: 100px; height: 100px"
                          :src="url" 
                          :preview-src-list="d_room_work_order_data.d_repair_info.img_list_four">
                        </el-image>
                      </el-card>
                    </el-timeline-item>

                    <el-timeline-item :timestamp="d_room_work_order_data.d_repair_info.web_status_timestamp_five" placement="top" :color="d_room_work_order_data.d_repair_info.web_status_color_five" >
                      <el-card>
                        <h4>维修后拍照</h4>
                        <p>{{ d_room_work_order_data.d_repair_info.work_order_deal_user }} 提交于 {{ d_room_work_order_data.d_repair_info.status_time_five }}</p>
                        <el-image 
                          v-for='url in d_room_work_order_data.d_repair_info.img_list_five' :key="url.key"
                          style="width: 100px; height: 100px"
                          :src="url" 
                          :preview-src-list="d_room_work_order_data.d_repair_info.img_list_five">
                        </el-image>
                      </el-card>
                    </el-timeline-item>

                    <el-timeline-item :timestamp="d_room_work_order_data.d_repair_info.web_status_timestamp_six" placement="top" :color="d_room_work_order_data.d_repair_info.web_status_color_six" >
                      <el-card>
                        <h4>离店打卡</h4>
                        <p>{{ d_room_work_order_data.d_repair_info.work_order_deal_user }} 提交于 {{ d_room_work_order_data.d_repair_info.status_time_six }}</p>
                        <p>打卡经纬度: {{ d_room_work_order_data.d_repair_info.work_order_leave_latitude }}</p>
                      </el-card>
                    </el-timeline-item>
                </el-timeline>
              </div>

            </div>


          </el-tab-pane>
          <el-tab-pane label="玩法更换派遣" name="third">
            <div style="padding: 10px 16px;">

              <el-form :model="d_dispatch_form" ref="d_dispatch_form" label-width="120px" width="300px">

                <el-form-item label="请选择派遣人" prop="changeId">
                  <el-select
                    v-model="d_dispatch_form.changeId"
                    size="small"
                    clearable
                    placeholder="请选择派遣人"
                    :ref="d_dispatch_shop_info"
                   >
                    <el-option
                      v-for="key, value in d_dispatch_shop_info.shop_change_play_user_list_info"
                      :key="value"
                      :label="key"
                      :value="value">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="需要更改的玩法" prop="play_deploy_now" >
                  <el-select v-model="d_dispatch_form.play_deploy_now" size="small"  clearable placeholder="请选择包间可用玩法" >
                    <el-option
                      v-for="item in deployPlayList"
                      :key="item.play_id"
                      :label="item.play_name"
                      :value="item.play_id">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item prop="time">
                  <el-button type="primary" round size="small" @click="dispatch_event_func(3)">确认派遣并修改包间状态</el-button>
                </el-form-item>

              </el-form>

              <el-divider><i class="el-icon-s-order"></i> 派单状态</el-divider>
              
              <div v-if="bChange === false" style="text-align:center;">
                <el-tag type="warning"> 当前无工单 </el-tag>
              </div>

              <div v-else>
                <el-timeline :v-mode="d_room_work_order_data">
                    <el-timeline-item :timestamp="d_room_work_order_data.d_change_info.web_status_timestamp_one" placement="top" :color="d_room_work_order_data.d_change_info.web_status_color_one" >
                      <el-card>
                        <h4>维修工单派遣时间</h4>
                        <p>{{ d_room_work_order_data.d_change_info.work_order_dispatch_user }} 提交于 {{ d_room_work_order_data.d_change_info.work_order_create_time }}</p>
                      </el-card>
                    </el-timeline-item>

                    <el-timeline-item :timestamp="d_room_work_order_data.d_change_info.web_status_timestamp_two" placement="top" :color="d_room_work_order_data.d_change_info.web_status_color_two" >
                      <el-card>
                        <h4>到店打卡</h4>
                        <p>{{ d_room_work_order_data.d_change_info.work_order_deal_user }} 提交于 {{ d_room_work_order_data.d_change_info.status_time_two }}</p>
                        <p>打卡经纬度: {{ d_room_work_order_data.d_change_info.work_order_arrive_latitude }}</p>
                      </el-card>
                    </el-timeline-item>

                    <el-timeline-item :timestamp="d_room_work_order_data.d_change_info.web_status_timestamp_three" placement="top" :color="d_room_work_order_data.d_change_info.web_status_color_three" >
                      <el-card>
                        <h4>更改玩法前拍照</h4>
                        <p>{{ d_room_work_order_data.d_change_info.work_order_deal_user }} 提交于 {{ d_room_work_order_data.d_change_info.status_time_three }}</p>
                        <el-image 
                          v-for='url in d_room_work_order_data.d_change_info.img_list_three' :key="url.key"
                          style="width: 100px; height: 100px"
                          :src="url" 
                          :preview-src-list="d_room_work_order_data.d_change_info.img_list_three">
                        </el-image>
                      </el-card>
                    </el-timeline-item>

                    <el-timeline-item :timestamp="d_room_work_order_data.d_change_info.web_status_timestamp_four" placement="top" :color="d_room_work_order_data.d_change_info.web_status_color_four" >
                      <el-card>
                        <h4>更改玩法后拍照</h4>
                        <p>{{ d_room_work_order_data.d_change_info.work_order_deal_user }} 提交于 {{ d_room_work_order_data.d_change_info.status_time_four }}</p>
                        <el-image 
                          v-for='url in d_room_work_order_data.d_change_info.img_list_four' :key="url.key"
                          style="width: 100px; height: 100px"
                          :src="url" 
                          :preview-src-list="d_room_work_order_data.d_change_info.img_list_four">
                        </el-image>
                      </el-card>
                    </el-timeline-item>

                    <el-timeline-item :timestamp="d_room_work_order_data.d_change_info.web_status_timestamp_five" placement="top" :color="d_room_work_order_data.d_change_info.web_status_timestamp_five" >
                      <el-card>
                        <h4>离店打卡</h4>
                        <p>{{ d_room_work_order_data.d_change_info.work_order_deal_user }} 提交于 {{ d_room_work_order_data.d_change_info.status_time_six }}</p>
                        <p>打卡经纬度: {{ d_room_work_order_data.d_change_info.work_order_leave_latitude }}</p>
                      </el-card>
                    </el-timeline-item>

                </el-timeline>
              </div>

            </div>
          </el-tab-pane>
          <!-- <el-tab-pane label="其他派遣" name="fourth">预留开发槽</el-tab-pane> -->
        </el-tabs>
      </div>
    </el-drawer>

  </div>
</template>

<script>
import room_info from '../components/room/room_info.vue'

export default {
  name: "room_list",

  components: {
    room_info
  },

  data() {
    return {
      d_room_list_from_line: {
        s_room_name: '',
        s_shop_name: '',
        l_room_status: [
            {value: 0, label: '空闲中'},
            {value: 1, label: '使用中'},
            {value: 2, label: '锁定中'},
            {value: 3, label: '待打扫'},
            {value: 4, label: '待维修'},
            {value: 5, label: '更改玩法'},
        ],
      },
      // 弹窗类型
      dialog_type: 1,
      // 当前选择内容
      d_select_room_data: {},

      // 分页最大值
      i_max_total: 1,

      ref_components: 1,

      // 包间操作表单
      b_room_dialog: false,
      // 包间操作是否全屏
      b_room_fullscreen: false,

      // 表单顶部操作按钮
      b_top_change_btn: true,
      b_top_find_btn: true,
      b_top_remove_btn: true,

      // 新增店铺表单
      b_add_room_dialog: false,
      // 是否全屏店铺表单
      b_add_room_fullscreen: false,
      
      // 查看店铺表单
      b_show_room_dialog: false,
      // 是否全屏查看店铺表单
      b_show_room_fullscreen: false,
      
      // 修改店铺表单
      b_change_room_dialog: false,
      // 是否全屏修改店铺表单
      b_change_room_fullscreen: false,

      // 录入设备的表单
      b_input_device_dialog: false,
      // 是否全屏录入设备表单
      b_input_device_fullscreen: false,

      // 设备控制弹窗
      bEquipmentControlDialog: false,
      // 设备控制弹窗是否全屏
      bEquipmentControlFullscreen: false,
      // 设备控制弹窗数据
      dEquipmentControlData: {},

      // 分页 首次展示第几页
      i_current_page: 1,
      
      // 包间状态搜索栏
      queryRoomStatus: undefined,

      // 表单多选内容
      multipleSelection: [],

      // 表单数据
      l_table_data: [],

      // 派遣抽屉
      is_show_dispatch: false,
      direction: 'rtl',
      dispatch_drawer_title: "派遣",
      d_dispatch_form: {},
      // 派遣的店铺信息
      d_dispatch_shop_info: {},
      // 选项卡激活索引
      s_dispatch_tab_active_index: "first",
      // 派遣事件的缓存数据
      d_dispatch_event_data: {},
      // 包间的工单缓存数据
      d_room_work_order_data: {
        d_clean_info: {},
      },

      bClean: false,
      bRepair: false,
      bChange: false,
      // 所有玩法的列表
      deployPlayList: [],
      // 设备录入弹窗
      deviceData: {},
      // 设备类型
      deviceType: [
        {value: 0, label: '门锁'},
        {value: 1, label: 'Switch断路器Zigbee'},
        {value: 2, label: '空调红外'},
        {value: 3, label: '智能开关Zigbee'},
        {value: 4, label: '智能插座Zigbee'},
        {value: 5, label: '智能空开Zigbee'},
        {value: 6, label: '室内应急灯(Switch)'},
      ],

    }
  },
  mounted() {
    // 判断是否是店铺界面跳转过来的查询
    this.judge_jump_page()

    // 刷新表单数数据
    this.refresh_table_data()
    
  },

  methods: {

    // 判断是否是店铺界面跳转过来的查询
    judge_jump_page(){
      if (this.$route.query.shop_id){
        this.s_query_shop_id = this.$route.query.shop_id
        this.d_room_list_from_line.s_shop_name = this.$route.query.shop_name
        this.$router.push({path: '/room_list'})
      }
    
    },
    // 刷新表单数据
    refresh_table_data(){

      var d_params = {
        page: this.i_current_page,
        page_size: 10,
      }

      if (this.d_room_list_from_line.s_shop_name){
        d_params.shop_name = this.d_room_list_from_line.s_shop_name
      }
      if (this.d_room_list_from_line.s_room_name){
        d_params.room_name = this.d_room_list_from_line.s_room_name
      }

      console.log(this.queryRoomStatus)
      if (this.queryRoomStatus != undefined){
        d_params.room_status = this.queryRoomStatus
      }

      console.log(d_params)
      console.log(this.d_room_list_from_line)

      this.$axios.get('/api/rooms/', {
        params: d_params
      }).then(res=>{
        console.log(res)
        this.i_max_total = res.data.count
        this.l_table_data = res.data.results
      })
    },

    // 搜索
    onSubmit(){
        this.refresh_table_data()
    },

    // 重置
    on_reset(){
      this.d_room_list_from_line = {
          s_room_name: '',
          s_shop_name: '',
          l_room_status: [
            {value: 0, label: '空闲中'},
            {value: 1, label: '使用中'},
            {value: 2, label: '锁定中'},
            {value: 3, label: '待打扫'},
            {value: 4, label: '待维修'},
            {value: 5, label: '更改玩法'},
              
          ],
      }
      // 重置当前url
      this.$router.push({path: '/room_list'})
      this.queryRoomStatus = undefined
      this.refresh_table_data()
    },

    // 分页触发事件
    change_current_func(i_index){
        console.log(i_index)
        this.i_current_page = i_index
        this.refresh_table_data()
    },

    // 表单多选触发事件
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(val.length)
      if (val.length === 0){
          this.b_top_change_btn = true,
          this.b_top_find_btn = true,
          this.b_top_remove_btn = true
          return
      }
      
      if (val.length === 1){
          this.b_top_change_btn = false,
          this.b_top_find_btn = false,
          this.b_top_remove_btn = false
          return
      }
      
      if (val.length > 1){
          this.b_top_change_btn = true,
          this.b_top_find_btn = true,
          this.b_top_remove_btn = false
          return
      }
    },

    // 监听输入框, 允许输入
    forceUpdate(){
        this.$forceUpdate();
    },

    // 新增包间
    add_room(){
      this.ref_components += 1
      this.d_select_room_data = {}
      this.b_room_fullscreen = false
      this.b_room_dialog = true
      this.dialog_type = 1
      
    },

    // 修改店铺
    change_room(d_info){
      this.ref_components += 1
      this.d_select_room_data = d_info
      this.b_room_fullscreen = false
      this.b_room_dialog = true
      this.dialog_type = 2
    },

    // 查看店铺
    show_room(d_info){
      this.ref_components += 1
      this.d_select_room_data = d_info
      this.b_room_fullscreen = false
      this.b_room_dialog = true
      this.dialog_type = 3
      
    },

    // 批量删除店铺
    top_remove_btn_func(){
        console.log('删除店铺')
        console.log(this.multipleSelection)
    },

    // 设备控制
    EquipmentControl(d_info){
      this.bEquipmentControlFullscreen = false
      this.bEquipmentControlDialog = true
      this.dEquipmentControlData = d_info
    },

    // 设备录入
    input_device_func(d_info){
      this.b_input_device_fullscreen = false
      this.b_input_device_dialog = true
      console.log(d_info)
      this.deviceData = {}
      // 设备录入的包间id
      this.deviceData.room_id = d_info.room_id
    },

    // 确定录入设备按钮绑定事件
    async input_device_define_func(){
      this.b_input_device_fullscreen = true
      this.b_input_device_dialog = false

      await this.$axios.post('/api/device/', this.deviceData).then(
        res => {
          this.$message({
            message: '录入成功',
            type: 'success'
          })
          this.refresh_table_data()
        }
      ).catch(
        err => {
          console.log(err)
          console.log(err.response)
          this.$message({
            message: '录入失败' + err.response.data.message,
            type: 'error'
          })
        }
      )
      
    },

    // 取消设备录入按钮绑定事件
    input_device_cancel_func(){
      this.b_input_device_fullscreen = true
      this.b_input_device_dialog = false
    },
    
    // 删除包间
    async removeRoomBtn(i_index, row){
      var s_url = '/api/rooms/' + row.room_id + '/'
      await this.$axios.delete(s_url).then(res=>{
        console.log(res)
        this.$message({
            message: '删除成功',
            type: 'success'
        })
        this.refresh_table_data()
      })
    },

     // 删除包间
    on_delete_room(row){
      var _this = this
      this.$confirm('此操作将永久删除该包间吗', '删除包间警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        _this.removeRoomBtn(row.room_id, row)
      }).catch(() => {
        _this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },

    // 包间信息组件回调
    room_info_callback(b_close){
      // console.log(d_info)
      this.refresh_table_data()
      this.b_room_dialog = b_close
    },

    // 派遣事件
    dispatch_event(d_info){
      this.is_show_dispatch = true
      // 缓存派遣事件触发的表格数据
      this.d_dispatch_event_data = JSON.parse(JSON.stringify(d_info))
      // console.log(d_info)
      this.dispatch_drawer_title = '派遣操作: ' + d_info.shop_name + '(' + d_info.room_name + ')'
      // 获取当前用户列表 - 工作人员 - 派遣 - 全部
      this.get_shop_user_list(d_info)
      // 获取当前包间的工单信息
      this.get_room_work_order_info()

    },

    // 获取当前包间的工单信息
    async get_room_work_order_info(){
      // 包间id
      var i_room_id = this.d_dispatch_event_data.room_id

      let d_params = {
        'status_filter': 0,
        'work_order_room_id': i_room_id,
      }

      let res = await this.$axios.get('/api/work_order/', {params: d_params})
      this.bClean = false
      this.bRepair = false
      this.bChange = false
      // 判断订单类型, work_order_type=1: 打扫, work_order_type=2: 维修, work_order_type=3: 更改玩法
      for (var i = 0; i < res.data.length; i++) {
        var d_item = res.data[i]
        if (d_item.work_order_type == 1){
          this.d_room_work_order_data.d_clean_info = d_item
          this.bClean = true
        } else if (d_item.work_order_type == 2){
          this.d_room_work_order_data.d_repair_info = d_item
          this.bRepair = true
        } else if (d_item.work_order_type == 3){
          this.d_room_work_order_data.d_change_info = d_item
          this.bChange = true
        }
      }
      console.log(this.d_room_work_order_data)

    },

    // 根据店铺id 获取派遣人员列表
    async get_shop_user_list(d_info){
      var s_url = '/api/shops/' + d_info.shop_id + '/'
      await this.$axios.get(s_url).then(res=>{
        console.log(res)
        this.d_dispatch_shop_info = res.data
        
      })
    },

    // 派遣抽屉关闭事件
    dispatch_close(done){
      this.$confirm('确认关闭？').then(_ => {done();}).catch(_ => {});
    },

    dispathc_rawer_tabs_click(tab, event){
      this.d_dispatch_form = {}
      this.get_room_work_order_info()
      // 索引
      let index = tab.index
      console.log(index)
      // tab索引
      if (index == 2){
        this.getPlayList()
      }

    },
   
    //派遣绑定事件
    async dispatch_event_func(work_order_type){

      // 包间id
      var s_room_id = this.d_dispatch_event_data.room_id

      // 事件类型
      // var work_order_type = 1
      // 派遣人
      if (work_order_type == 1){
        var s_dispatch_user_id = this.d_dispatch_form.cleanId
      }
      else if (work_order_type == 2){
        var s_dispatch_user_id = this.d_dispatch_form.repairId
      }
      else if (work_order_type == 3){
        var s_dispatch_user_id = this.d_dispatch_form.changeId
      }
      else {
        return
      }

      var d_data = {
        "work_order_type": work_order_type,
        "work_order_deal_user_id": s_dispatch_user_id,
        "work_order_room_id": s_room_id,
      }

      if (work_order_type == 2){
        d_data.work_order_reason = this.d_dispatch_form.work_order_reason
      }
      else if (work_order_type == 3){
        d_data.work_order_change_play_deploy = this.d_dispatch_form.play_deploy_now
      }

      console.log(d_data)

      var s_url = '/api/work_order/'
      await this.$axios.post(s_url, d_data).then(
        res => {
          this.$message({
            message: '派遣成功',
            type: 'success'
          })
          this.get_room_work_order_info()

        }
      ).catch(
        err => {
          console.log(err)
          console.log(err.response)
          this.$message({
            message: '派遣失败' + err.response.data.message,
            type: 'error'
          })
        }
      )
    },

    // 获取当前所有可用玩法
    async getPlayList(){
      var d_query_play_data = {"query_list": ["play_name"]}
      let res = await this.$axios.get('/api/play_deploy/', {params: d_query_play_data})
      this.deployPlayList = res.data
      console.log(this.deployPlayList)
      console.log(this.d_dispatch_event_data)
    },

    // 断路器断电
    async PowerLoss(){
      var sRoomId = this.dEquipmentControlData.room_id
      await this.$axios.post('/api/breaker/?room_id=' + sRoomId, {"is_open": false}).then(res => {
          this.$message({
            message: '断电成功',
            type: 'success'
          })
        }
      ).catch(
        err => {
          console.log(err)
          console.log(err.response)
          this.$message({
            message: '断电失败' + err.response.data.message,
            type: 'error'
          })
      })
    },

    // 断路器通电
    async PowerOn(){
      var sRoomId = this.dEquipmentControlData.room_id
      await this.$axios.post('/api/breaker/?room_id=' + sRoomId, {"is_open": true}).then(res => {
          this.$message({
            message: '通电成功',
            type: 'success'
          })
        }
      ).catch(
        err => {
          console.log(err)
          console.log(err.response)
          this.$message({
            message: '通电失败' + err.response.data.message,
            type: 'error'
          })
      })
    },

    // 开门
    async OpenDoor(){
      var sRoomId = this.dEquipmentControlData.room_id
      await this.$axios.post('/api/unlock/?room_id=' + sRoomId).then(res => {
          this.$message({
            message: '开门成功',
            type: 'success'
          })
        }
      ).catch(
        err => {
          console.log(err)
          console.log(err.response)
          this.$message({
            message: '开门失败' + err.response.data.message,
            type: 'error'
          })
      })
      
    },

    // 开启空调
    async OpenAirCondition(){
      var sRoomId = this.dEquipmentControlData.room_id
      await this.$axios.post('/api/air/?room_id=' + sRoomId, {"PowerOn": 0}).then(res=>{
        this.$message({
          message: '开启空调成功',
          type: 'success'
        })
      }).catch(err=>{
        this.$message({
          message: '开启空调失败' + err.response.data.message,
          type: 'error'
        })
      })
      
    },

    // 关闭空调
    async CloseAirCondition(){
      var sRoomId = this.dEquipmentControlData.room_id
      await this.$axios.post('/api/air/?room_id=' + sRoomId, {"PowerOff": 0}).then(res=>{
        this.$message({
          message: '关闭空调成功',
          type: 'success'
        })
      }).catch(err=>{
        this.$message({
          message: '关闭空调失败' + err.response.data.message,
          type: 'error'
        })
      })
    },

  },
}
</script>

<style>
.room-list-main{
    background-color: #fff;
    padding: 12px 16px;
}

.red_point{
    src: url(../assets/red.svg);
}

.dialog-title-button {
		float: right;
		padding: 10px;
		border: 0;
    border-style: 0; 
    
	}

  
</style>
